"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RentTrackerMockStates = void 0;
var RentTrackerMockStates;
(function (RentTrackerMockStates) {
    // Flex Classic Non-SLC - Happy path
    RentTrackerMockStates["SCHEDULED"] = "scheduled";
    RentTrackerMockStates["SCHEDULED_NEXT_MONTH"] = "scheduledNextMonth";
    RentTrackerMockStates["FIRST_PAYMENT_PROCESSING"] = "firstPaymentProcessing";
    RentTrackerMockStates["FUNDED_FIRST_PAYMENT"] = "fundedFirstPayment";
    RentTrackerMockStates["FIRST_PAYMENT_PAID"] = "firstPaymentPaid";
    RentTrackerMockStates["RENT_PROCESSING"] = "rentProcessing";
    RentTrackerMockStates["MMF_NOT_PAID"] = "mmfNotPaid";
    RentTrackerMockStates["COVERED"] = "covered";
    RentTrackerMockStates["CANNOT_REPAY"] = "cannotRepay";
    RentTrackerMockStates["TWO_REPAYMENTS"] = "twoRepayments";
    RentTrackerMockStates["THREE_REPAYMENTS"] = "threeRepayments";
    RentTrackerMockStates["CREDIT_CARD_IN_APP"] = "creditCardInApp";
    RentTrackerMockStates["MLA_IN_APP"] = "mlaInApp";
    RentTrackerMockStates["FLEX_FUNDS_FULLY_FUNDED_FIRST_PAYMENT"] = "flexFundsFullyFundedFirstPayment";
    RentTrackerMockStates["FLEX_FUNDS_ZERO_BALANCE_FIRST_PAYMENT"] = "flexFundsZeroBalanceFirstPayment";
    // Flex Classic - Episodic
    RentTrackerMockStates["AUTOPILOT_NOT_ELIGIBLE"] = "autopilotNotEligible";
    RentTrackerMockStates["AUTOPILOT_NOT_CONFIGURED"] = "autopilotNotConfigured";
    // Flex Classic Non-SLC - Sad path
    RentTrackerMockStates["SECOND_PAYMENT_FAILED"] = "secondPaymentFailed";
    RentTrackerMockStates["THIRD_PAYMENT_FAILED"] = "thirdPaymentFailed";
    // Flex Classic SLC - Happy path
    RentTrackerMockStates["SLC_FLEX_CLASSIC_GET_READY"] = "slcFlexClassicGetReady";
    RentTrackerMockStates["SLC_FLEX_CLASSIC_RENT_PAYMENT_PROCESSING"] = "slcFlexClassicRentPaymentProcessing";
    RentTrackerMockStates["SLC_FLEX_CLASSIC_COVERED"] = "slcFlexClassicCovered";
    RentTrackerMockStates["SLC_AUTOPAY_ON_RENT_PROTECT_ON_DEP_NOT_PD"] = "slcAutopayOnRentProtectOnDepNotPd";
    RentTrackerMockStates["SLC_AUTOPAY_ON_RENT_PROTECT_ON_DEP_PD"] = "slcAutopayOnRentProtectOnDepPd";
    RentTrackerMockStates["SLC_AUTOPAY_ON_RENT_PROTECT_ON_PAYING_RENT"] = "slcAutopayOnRentProtectOnPayingRent";
    RentTrackerMockStates["SLC_AUTOPAY_ON_RENT_PROTECT_ON_PAYMENT_SCHD"] = "slcAutopayOnRentProtectOnPaymentSchd";
    RentTrackerMockStates["SLC_AUTOPAY_ON_RENT_PROTECT_ON_PAYMENT_PAID"] = "slcAutopayOnRentProtectOnPaymentPaid";
    RentTrackerMockStates["FSLC_AUTOPAY_ON_RENT_PROTECT_OFF_DEP_NOT_PD"] = "fslcAutopayOnRentProtectOffDepNotPd";
    RentTrackerMockStates["FSLC_AUTOPAY_ON_RENT_PROTECT_OFF_DEP_PD"] = "fslcAutopayOnRentProtectOffDepPd";
    RentTrackerMockStates["FSLC_AUTOPAY_ON_RENT_PROTECT_OFF_PAYING_RENT"] = "fslcAutopayOnRentProtectOffPayingRent";
    RentTrackerMockStates["FSLC_AUTOPAY_ON_RENT_PROTECT_OFF_PAYMENT_SCHD"] = "fslcAutopayOnRentProtectOffPaymentSchd";
    RentTrackerMockStates["FSLC_AUTOPAY_ON_RENT_PROTECT_OFF_PAYMENT_PAID"] = "fslcAutopayOnRentProtectOffPaymentPaid";
    RentTrackerMockStates["FSLC_RELINK_SERVICE_ISSUE"] = "fslcRelinkServiceIssue";
    RentTrackerMockStates["CREDIT_BUILDER_REPAYMENT_FAILED"] = "creditBuilderRepaymentFailed";
    RentTrackerMockStates["CREDIT_BUILDER_CANCELED_USER"] = "creditBuilderCanceledUser";
    RentTrackerMockStates["CREDIT_BUILDER_WALLET_ENABLED"] = "creditBuilderWalletEnabled";
    // Flex Classic SLC - Sad path
    RentTrackerMockStates["SLC_1ST_REPAYMENT_FAILED"] = "slc1stRepaymentFailed";
    RentTrackerMockStates["SLC_2ND_REPAYMENT_FAILED"] = "slc2ndRepaymentFailed";
    // Flex Anywhere Non-SLC - Happy path
    RentTrackerMockStates["SCHEDULED_OON"] = "scheduledOon";
    RentTrackerMockStates["SCHEDULED_EXISTING_OON_USER"] = "scheduledExistingOonUser";
    RentTrackerMockStates["READY_TO_PAY"] = "readyToPay";
    RentTrackerMockStates["FIRST_PAYMENT_PAID_OON"] = "firstPaymentPaidOon";
    RentTrackerMockStates["RENT_PAID_OON"] = "rentPaidOon";
    RentTrackerMockStates["COVERED_OON"] = "coveredOon";
    RentTrackerMockStates["FLEX_ANYWHERE_MULTIPLE_REPAYMENTS"] = "flexAnywhereMultipleRepayments";
    // Flex Anywhere SLC Simplified Payments - Happy Path
    RentTrackerMockStates["READY_TO_PAY_OON_SLC_SP_ENABLED"] = "oonReadyToPaySlcSPEnabled";
    RentTrackerMockStates["TWO_REPAYMENTS_OON_SLC_SP_ENABLED_MONTH_TWO"] = "oonTwoRepaymentsSlcEnabledMonthTwo";
    // Flex Anywhere SLC Non-Simplified Payments - Happy Path
    RentTrackerMockStates["READY_TO_PAY_OON_SLC_SP_DISABLED"] = "oonReadyToPaySlcSPDisabled";
    RentTrackerMockStates["READY_TO_PAY_OON_SLC_SP_DISABLED_MONTH_TWO"] = "oonReadyToPaySlcSPDisabledMonthTwo";
    RentTrackerMockStates["READY_TO_PAY_OON_SLC_SP_DISABLED_MONTH_TWO_ADDITIONAL_DEPOSIT"] = "oonReadyToPaySlcSPDisabledMonthTwoAdditionalDeposit";
    RentTrackerMockStates["TWO_REPAYMENTS_OON_SLC_SP_DISABLED_MONTH_TWO"] = "oonTwoRepaymentsSlcDisabledMonthTwo";
    RentTrackerMockStates["READY_TO_PAY_OON_SLC_SP_DISABLED_MONTH_TWO_DEPOSIT_PAID"] = "oonReadyToPaySlcSPDisabledMonthTwoDepositPaid";
    // Flex Anywhere Self Pay Payment Method
    RentTrackerMockStates["FLEX_ANYWHERE_DDA_READY"] = "flexAnywhereDDAReady";
    RentTrackerMockStates["FLEX_ANYWHERE_DDA_EXISTING_READY"] = "flexAnywhereDDAExistingReady";
    RentTrackerMockStates["FLEX_ANYWHERE_DDA_READY_TO_PAY"] = "flexAnywhereDDAReadyToPay";
    RentTrackerMockStates["FLEX_ANYWHERE_EARLY_PAY"] = "flexAnywhereEarlyPay";
    RentTrackerMockStates["FLEX_ANYWHERE_DDA_FIRST_PAYMENT_PAID"] = "flexAnywhereDDAFirstPaymentPaid";
    RentTrackerMockStates["FLEX_ANYWHERE_OPTED_OUT"] = "flexAnywhereOptedOut";
    RentTrackerMockStates["USED_LESS_THAN_RENT_AMT_OON"] = "usedLessThanRentAmtOon";
    // Episodic - Non-SLC Classic
    RentTrackerMockStates["READY_TO_PAY_AUTOPILOT_ENABLED"] = "readyToPayAutopilotEnabled";
    RentTrackerMockStates["READY_TO_PAY_AUTOPILOT_DISABLED"] = "readyToPayAutopilotDisabled";
    RentTrackerMockStates["READY_TO_PAY_SLC_AUTOPILOT_ENABLED"] = "readyToPaySLCAutopilotEnabled";
    RentTrackerMockStates["READY_TO_PAY_SLC_AUTOPILOT_DISABLED"] = "readyToPaySLCAutopilotDisabled";
    RentTrackerMockStates["READY_TO_PAY_SLC_SP_OFF_AUTOPILOT_ENABLED"] = "readyToPaySLCSPOffAutopilotEnabled";
    RentTrackerMockStates["READY_TO_PAY_SLC_SP_OFF_AUTOPILOT_DISABLED"] = "readyToPaySLCSPOffAutopilotDisabled";
    // Episodic - SLC Classic
    RentTrackerMockStates["READY_TO_PAY_SLC_CLASSIC_EPISODIC"] = "readyToPaySlcClassicEpisodic";
    // Scalable DDA
    RentTrackerMockStates["ADDITIONAL_DEPOSIT_NEEDED"] = "additionalDepositNeeded";
    // Flex Anywhere - Sad path
    RentTrackerMockStates["READY_TO_PAY_TOO_MANY_TRIES"] = "readyToPayTooManyTries";
    RentTrackerMockStates["READY_TO_PAY_FAILED"] = "readyToPayFailed";
    RentTrackerMockStates["SECOND_PAYMENT_FAILED_OON"] = "secondPaymentFailedOon";
    // Rent not covered for the month
    RentTrackerMockStates["NOT_COVERED"] = "notCovered";
    RentTrackerMockStates["NOT_COVERED_USER_INITIATED"] = "notCoveredUserInitiated";
    // Realpage/Entrata fee passthrough
    RentTrackerMockStates["PROPERTY_FEE_PASSTHROUGH"] = "propertyFeePassthrough";
    // Inactive account states
    RentTrackerMockStates["PAUSED"] = "paused";
    RentTrackerMockStates["CANCELED"] = "canceled";
    RentTrackerMockStates["SUSPENDED"] = "suspended";
    // Fraud states
    RentTrackerMockStates["DISPUTE"] = "dispute";
    RentTrackerMockStates["BLOCKED"] = "blocked";
    RentTrackerMockStates["REVOKED"] = "revoked";
    // IV Suspension
    RentTrackerMockStates["IV_SUSPENSION"] = "ivSuspension";
    // Technical issues
    RentTrackerMockStates["TECHNICAL_ISSUE"] = "technicalIssue";
    RentTrackerMockStates["TECHNICAL_ISSUE_NO_CARD"] = "technicalIssueNoCard";
    RentTrackerMockStates["CREDIT_BUILDER_TECHNICAL_ISSUE"] = "creditBuilderTechnicalIssue";
})(RentTrackerMockStates || (exports.RentTrackerMockStates = RentTrackerMockStates = {}));
